import React, { useEffect } from 'react';
import type { FunctionComponent } from 'react';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useI18n } from '@whizz/react-i18n';
import { useIdentity } from '@whizz/react-identity';
import { useQuery } from 'react-query';
import { repository } from '@whizz/api-client';
import { useLocalStorage } from 'react-use';
import { useHistory } from 'react-router-dom';
import { useClassSelector } from '../../hooks/filters/useClassSelector';
import { QUERIES_IDS, ROUTES } from '../../util/vars';
import { getWelcomeLocaleFlags } from './modules/welcomeShared';
import WelcomeAdmin from './WelcomeAdmin';
import WelcomeStaff from './WelcomeStaff';

const Welcome: FunctionComponent = () => {
  const { me } = useIdentity();
  const { locale } = useI18n();
  const history = useHistory();
  const isAdmin = (me as Teacher).getIsAdmin();
  const teacherId = (me as Teacher).getId();
  const { hasTraining, textAlign } = getWelcomeLocaleFlags(locale);

  const staffQuery = useQuery(
    [ QUERIES_IDS.STAFF ],
    () => repository.StaffRepository.getStaff(),
  );

  const classesQuery = useQuery(
    [ QUERIES_IDS.CLASSES, teacherId ],
    () => repository.NewTeacherRepository.getClasses(teacherId!),
    {
      enabled: null != teacherId,
      placeholderData: [],
    },
  );

  const [ classSelectorElement ] = useClassSelector(
    me?.username as string,
    classesQuery.data!,
    'center',
    'sm',
    () => history.push(ROUTES.home),
  );
  const classSelector = classesQuery.isFetched ? classSelectorElement : null;

  const [ , setHasSeenWelcome ] = useLocalStorage(`has_seen_welcome_${me?.username as string}`, false);
  useEffect(() => {
    setHasSeenWelcome(true);
  }, []);

  return isAdmin
    ? <WelcomeAdmin hasTraining={hasTraining} textAlign={textAlign} staffQuery={staffQuery} classSelector={classSelector} />
    : <WelcomeStaff hasTraining={hasTraining} textAlign={textAlign} staffQuery={staffQuery} classSelector={classSelector} />;
};

export default Welcome;
